import { Message } from '@kvdbil/components';
import React from 'react';

function Restrictions({ text }: { text: string }) {
  return (
    <Message type="warning" withIcon textCenter={false}>
      {text}
    </Message>
  );
}

export default Restrictions;
